import { parser } from './parser.js';
import { filterFieldStyleTags } from '../decorations/highlight.js';

/** @internal */
export const previousFilterFieldParser = parser.configure({
  props: [filterFieldStyleTags],
});
